import { useGetQuoteLineById } from "@/common/api/queries";
import { Quote } from "@/common/types/quote/quote.type";
import { transformAddress } from "@/common/utils";
import { HeaderAddress, MainHeader } from "@/components";
import AirxContactSection from "@/components/Quotes/AirxContactSection/AirxContactSection";
import CustomerQuoteLineForm from "@/components/Quotes/CustomerQuoteLine/CustomerQuoteLineForm";
import ManualQuoteResponse from "@/components/Quotes/ManualQuoteResponse/ManualQuoteResponse";
import MapView from "@/components/Quotes/MapView/MapView";
import QuoteLineHeader from "@/components/Quotes/QuoteLineHeader/QuoteLineHeader";
import VendorQuoteLineForm from "@/components/Quotes/VendorQuote/VendorQuoteLineForm";
import { useLocation, useParams } from "react-router";

export default function AIRXSingleQuoteLinePage() {
  const params = useParams();
  const location = useLocation().state;
  const quoteLineId = params.quoteLineId;
  const { data: quoteData } = useGetQuoteLineById(quoteLineId);
  const source = location?.source || "customer";
  const addressAData = quoteData?.quote?.addressA
    ? transformAddress(quoteData.quote.addressA)
    : null;
  return (
    <>
      <MainHeader pageName={"Quote Line ID: " + params.quoteLineId} />
      <div className="px-5">
        <QuoteLineHeader
          RFSdate={quoteData?.quote?.RFSdate || null}
          dueDate={quoteData?.quote?.dueDate || null}
          customerProjectNumber={
            quoteData?.quote?.customerProjectNumber || null
          }
          endCustomerName={quoteData?.quote?.endCustomerName || null}
          customerName={quoteData?.quote?.initiator.companyName || null}
          createdAt={quoteData?.quote?.createdAt || null}
          localContactName={quoteData?.quote?.localContactName || null}
          localContactNumber={quoteData?.quote?.localContactNumber || null}
        />
      </div>
      <div className="flex gap-4 h-[330px] overflow-hidden w-full px-5">
        <div className="flex flex-col gap-4 bg-white rounded-lg w-full">
          <div className="flex justify-between gap-4">
            {addressAData !== null && (
              <HeaderAddress
                addressAData={addressAData}
                addressBData={
                  quoteData?.quote?.addressB
                    ? transformAddress(quoteData?.quote?.addressB)
                    : undefined
                }
              />
            )}
          </div>
          <div className="px-4 pb-4 rounded-lg w-full">
            {addressAData !== null && addressAData?.position?.lat !== null && (
              <MapView
                addressAData={addressAData}
                addressBData={
                  quoteData?.quote?.addressB
                    ? transformAddress(quoteData?.quote?.addressB)
                    : undefined
                }
              />
            )}
          </div>
        </div>

        <AirxContactSection source={source} />
      </div>
      <div className="px-5">
        {quoteData && (
          <div className=" mt-5 my-5 rounded-lg w-full">
            {source === "vendor" ? (
              quoteData?.price?.source === "manual" &&
              quoteData?.quote?.status === "Pending" ? (
                <ManualQuoteResponse
                  {...({
                    ...quoteData?.price,
                    quoteType: quoteData?.quoteType,
                    view: "vendor",
                    quoteId: quoteData.quote.id,
                    customerId: quoteData.quote.initiatorId,
                    vendorId: quoteData.quote.implementerId,
                    quoteLineId: quoteData.id,
                  } as any)}
                />
              ) : (
                <VendorQuoteLineForm
                  productData={quoteData}
                  productType={quoteData?.price?.type}
                  quoteData={quoteData?.quote as Quote}
                />
              )
            ) : (
              <CustomerQuoteLineForm
                productData={quoteData}
                productType={quoteData?.price?.type}
                quoteData={quoteData?.quote as Quote}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
}
